import Vue from 'vue'

Vue.filter('toHoursMinutes', function (value) {
  var floatValue = parseFloat(value)
  
  // start by converting to seconds
  var seconds = (floatValue * 3600)
  // we're given hours, so let's get those the easy way
  var hours = Math.floor(floatValue)
  // since we've "calculated" hours, let's remove them from the seconds variable
  var seconds = seconds - (hours * 3600)
  // calculate minutes left
  var minutes = Math.round(seconds / 60)

  // var decimalTime = parseFloat(value);
  // decimalTime = decimalTime * 60 * 60;
  // var hours = Math.floor((decimalTime / (60 * 60)));
  // decimalTime = decimalTime - (hours * 60 * 60);
  // var minutes = Math.floor((decimalTime / 60));
  // decimalTime = decimalTime - (minutes * 60);
  // var seconds = Math.round(decimalTime);
  
  if (hours < 10) {
    hours = "0" + hours;
  }
  
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  
  if (hours > 0 || minutes > 0) {
    return `${hours}:${minutes}`
  } else {
    return '00:00'
  }
})